import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { downloadGenericPdf } from 'actions/landlordNoticesActions';

import { getTranslatedString } from 'helpers/i18n';
import { AntdButton as Button } from '@yuhuinc/ui-library/';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledButton = styled(Button)`
  margin-left: 8px;
`;

const HeaderButtons = ({ values, downloadGenericPdf }) => {
  return (
    <StyledContainer>
      <StyledButton
        type="button"
        onClick={() => downloadGenericPdf(values.id)}
        label={getTranslatedString('landlordPortal.noticeDetailsOverview.genericPdf')}
        size="small"
      />
    </StyledContainer>
  );
};
const mapStoreToProps = (store) => {};
const mapDispatchToProps = {
  downloadGenericPdf,
};

export default connect(mapStoreToProps, mapDispatchToProps)(HeaderButtons);
